import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import TextBox from '../common/inputs/textBox';
import Button from '../common/inputs/button';
import ErrorFeedback from '../common/feedback/errorFeedback';
import Logo from '../../../../public/images/logo_flexpay_login.png';

const ResetPasswordForm = props => {
  const {
    errors,
    handleResetPassword,
    handleOnChange,
    status,
    loading,
    formData
  } = props;
  return (
    <div className="login_container">
      <div className='login_top_logo'>
         <img src={Logo} height="100%" alt={useIntl().formatMessage({ id: "common.companyName" })}/>
      </div>
      <div className="login_content">
        <div className="login_content_form">
          <div className="login_content_form_title">
            <h1><FormattedMessage id="common.companyName"/></h1>
            <h3><FormattedMessage id="resetPassword.changePassword"/></h3>
          </div>
          {status!==200 && (
            <div className="login_content_form_inputs">
              <TextBox
                styleType={Constants.interface.inputs.styleType.STANDARD}
                type={Constants.interface.inputs.type.PASSWORD}
                id="newPassword"
                value={formData.newPassword}
                onChange={handleOnChange}
                onKeyEnter={handleResetPassword}
                labelLocale={<FormattedMessage id="resetPassword.newPassword"/>}
              />
              <TextBox
                styleType={Constants.interface.inputs.styleType.STANDARD}
                type={Constants.interface.inputs.type.PASSWORD}
                id="newPasswordRepeat"
                value={formData.newPasswordRepeat}
                onChange={handleOnChange}
                onKeyEnter={handleResetPassword}
                labelLocale={<FormattedMessage id="resetPassword.newPasswordRepeat"/>}
              />
              <ErrorFeedback
                status={status}
                optionalStatusErrors={{
                  "422": ("reset_password_token" in errors) ? 
                      <FormattedMessage id="resetPassword.errors.expiredLink"/> : 
                      <FormattedMessage id="resetPassword.errors.invalidNewPassword"/>
                  }}
              />
            </div>
          )}
          {status!==200 && (
            <div className="login_content_form_button">
              <Button
                disabled={loading}
                loading={loading}
                onClick={handleResetPassword}
                labelLocale={<FormattedMessage id="resetPassword.resetPasswordAction"/>}
              />
            </div>
          )}
          {status===200 && (
            <div className="login_content_form_inputs">
              <p><FormattedMessage id="resetPassword.successMessage"/></p>
              <Link to={Constants.app.routes.login}>
                <FormattedMessage id="resetPassword.successRedirectLinkText"/>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./source/client/components/resetPassword/resetPasswordForm.jsx